import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";
import { HbIdSchema } from "../traits";

export enum ExtractCategorySchemaEnum {
	ExtractCategory = "ExtractCategory"
};

export const ExtractCategorySchema = AbstractExtractSchema
	.merge(HbIdSchema)
	.merge(z.object({
		"@id": z.string(), // "api/extract_categories/1"
		"@type": z.string(), // "ExtractCategory"
		id: z.number(), // 1
		actif: z.string(), // "1"
		libelle: z.string(), // "Achat"
	}))
	.describe(ExtractCategorySchemaEnum.ExtractCategory);

export type ExtractCategory = z.infer<typeof ExtractCategorySchema>;
